import { capitalize } from 'Data/format.js'

function formatAnswer(value) {
  if (Array.isArray(value)) {
    return value.join(', ')
  }

  if (value === true) {
    return 'Yes'
  }
  if (value === false) {
    return 'No'
  }

  return value
}

export function populateTemplate(questions, template, values) {
  if (!template) return formatAnswer(template)

  let re = /\{\{(.+?)\}\}/gim
  let output = template

  try {
    let t = [...template.matchAll(re)]
    t.forEach(item => {
      output = output.replaceAll(
        item[0],
        capitalize(
          values[
            item[1] ||
              values[
                questions.find(question => question?.resource_id === item[1])
                  ?.id
              ]
          ]
        )
      )
    })
  } catch (_) {}

  return formatAnswer(output)
}

export function hasTextTransform(value) {
  return value || 'capitalize'
}
